import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import { TextStyle, FontSize } from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import TextAlign from "@tiptap/extension-text-align";
import Highlight from "@tiptap/extension-highlight";
import { Table, TableRow, TableCell, TableHeader } from "@tiptap/extension-table";

// Estende o nó Table para suportar alinhamento da tabela inteira (não do conteúdo interno)
const AlignableTable = Table.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			tableAlign: {
				default: "left",
				parseHTML: (el) => el.getAttribute("data-table-align") || "left",
				renderHTML: (attrs) => {
					const styles = {
						left:   "width: 100%; margin-left: 0; margin-right: auto;",
						center: "width: auto; margin-left: auto; margin-right: auto;",
						right:  "width: auto; margin-left: auto; margin-right: 0;",
					};
					return {
						"data-table-align": attrs.tableAlign,
						style: styles[attrs.tableAlign] || "",
					};
				},
			},
		};
	},
});

export const sharedExtensions = [
	StarterKit,
	Underline,
	TextStyle,
	FontSize,
	Color,
	Highlight.configure({ multicolor: true }),
	TextAlign.configure({ types: ["heading", "paragraph"] }),
	AlignableTable.configure({ resizable: false }),
	TableRow,
	TableHeader,
	TableCell,
];
